module.exports = __webpack_public_path__ + "static/media/kosice-online.5da6271b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/kosice-online.png
// module id = 424
// module chunks = 0